import React from 'react';
import { appConfig } from '../config/appConfig';

function IndexInstructions() {
  return (
    <div className="index-instructions">
      <h2>Instrucciones para crear índices en Firebase Firestore</h2>
      
      <div className="instructions-section">
        <h3>Para la colección "levapan_reservations":</h3>
        <ol>
          <li>Abre la <a href="https://console.firebase.google.com/" target="_blank" rel="noreferrer">consola de Firebase</a></li>
          <li>Selecciona el proyecto Firebase exclusivo de {appConfig.companyName}</li>
          <li>En el menú lateral, haz clic en "Firestore Database"</li>
          <li>Selecciona la pestaña "Índices"</li>
          <li>Haz clic en "Crear índice"</li>
          <li>Selecciona la colección "levapan_reservations"</li>
          <li>Añade los siguientes campos:
            <ul>
              <li>userId (Ascending)</li>
              <li>createdAt (Descending)</li>
            </ul>
          </li>
          <li>Haz clic en "Crear índice"</li>
        </ol>

        <div className="additional-index">
          <p>También crea otro índice para la colección "levapan_reservations" con:</p>
          <ul>
            <li>userId (Ascending)</li>
            <li>status (Ascending)</li>
            <li>createdAt (Descending)</li>
          </ul>
        </div>
      </div>
      
      <div className="instructions-section">
        <h3>Para la colección "levapan_reservas":</h3>
        <ol>
          <li>En la misma sección de índices</li>
          <li>Haz clic en "Crear índice"</li>
          <li>Selecciona la colección "levapan_reservas"</li>
          <li>Añade los siguientes campos:
            <ul>
              <li>usuario_id (Ascending)</li>
              <li>estado (Ascending)</li>
              <li>fecha_reserva (Descending)</li>
              <li>hora_reserva (Descending)</li>
            </ul>
          </li>
          <li>Haz clic en "Crear índice"</li>
        </ol>
      </div>
      
      <div className="note">
        <p><strong>Nota:</strong> Después de crear los índices, puede tomar unos minutos hasta que estén activos.</p>
      </div>
    </div>
  );
}

export default IndexInstructions;
